import React from 'react';
import { BarChart3, ChevronLeft, ChevronRight } from 'lucide-react';
import SCurveChart from './SCurveChart';
import CombinedSCurveChart from './CombinedSCurveChart';

const SCurveAnalysisSection = ({
  currentScurveView,
  handleNextScurveView,
  handlePrevScurveView,
  setCurrentScurveView,
  sCurveData1,
  sCurveData2,
  combinedSCurveData,
  comparisonResults
}) => {
  const getSCurveChartContent = () => {
    if (currentScurveView === 0 && sCurveData1) {
      return (
        <SCurveChart
          data={sCurveData1}
          title={`${sCurveData1.name} S-Curve`}
        />
      );
    } else if (currentScurveView === 1 && sCurveData2) {
      return (
        <SCurveChart
          data={sCurveData2}
          title={`${sCurveData2.name} S-Curve`}
        />
      );
    } else if (currentScurveView === 2 && combinedSCurveData) {
      return (
        <CombinedSCurveChart
          data={combinedSCurveData}
          title="Combined S-Curve Comparison"
        />
      );
    }
    return (
      <div className="flex items-center justify-center h-full text-gray-400">
        <p>Select ships to view S-Curve.</p>
      </div>
    );
  };

  if (!comparisonResults || (!sCurveData1 && !sCurveData2)) {
    return null;
  }

  return (
    <div className="mt-8 bg-white rounded-2xl p-8 shadow-lg border border-blue-100">
      <h2 className="text-xl font-semibold text-gray-800 mb-6 flex items-center">
        <BarChart3 className="w-5 h-5 mr-2 text-blue-500" />
        S-Curve Progress Analysis
      </h2>
      <div className="relative">
        <div className="overflow-hidden rounded-xl border border-gray-200 p-4 bg-gradient-to-br from-gray-50 to-white">
          {getSCurveChartContent()}
        </div>
        <div className="absolute top-1/2 left-0 right-0 flex justify-between transform -translate-y-1/2 px-4">
          <button
            onClick={handlePrevScurveView}
            className="p-2 bg-blue-500 text-white rounded-full shadow-lg hover:bg-blue-600 transition-colors duration-200"
          >
            <ChevronLeft size={24} />
          </button>
          <button
            onClick={handleNextScurveView}
            className="p-2 bg-blue-500 text-white rounded-full shadow-lg hover:bg-blue-600 transition-colors duration-200"
          >
            <ChevronRight size={24} />
          </button>
        </div>
        <div className="flex justify-center mt-4 space-x-2">
          <button
            onClick={() => setCurrentScurveView(0)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${currentScurveView === 0 ? 'bg-blue-600 text-white shadow' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
            disabled={!sCurveData1}
          >
            {sCurveData1?.name || "Ship 1"}
          </button>
          <button
            onClick={() => setCurrentScurveView(1)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${currentScurveView === 1 ? 'bg-indigo-600 text-white shadow' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
            disabled={!sCurveData2}
          >
            {sCurveData2?.name || "Ship 2"}
          </button>
          <button
            onClick={() => setCurrentScurveView(2)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${currentScurveView === 2 ? 'bg-purple-600 text-white shadow' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
            disabled={!combinedSCurveData}
          >
            Combined S-Curve
          </button>
        </div>
      </div>
    </div>
  );
};

export default SCurveAnalysisSection;